
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class IconArrow extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isOpen!: boolean
}
